import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\SendSupplierOrderToSupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/SendSupplierOrderToSupplierController.php
* @route '/api/supplier-order/{supplier_order}/send-to-supplier'
*/
const SendSupplierOrderToSupplierController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendSupplierOrderToSupplierController.url(args, options),
    method: 'post',
})

SendSupplierOrderToSupplierController.definition = {
    methods: ["post"],
    url: '/api/supplier-order/{supplier_order}/send-to-supplier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SupplierOrder\SendSupplierOrderToSupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/SendSupplierOrderToSupplierController.php
* @route '/api/supplier-order/{supplier_order}/send-to-supplier'
*/
SendSupplierOrderToSupplierController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return SendSupplierOrderToSupplierController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\SendSupplierOrderToSupplierController::__invoke
* @see app/Http/Controllers/SupplierOrder/SendSupplierOrderToSupplierController.php
* @route '/api/supplier-order/{supplier_order}/send-to-supplier'
*/
SendSupplierOrderToSupplierController.post = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendSupplierOrderToSupplierController.url(args, options),
    method: 'post',
})

export default SendSupplierOrderToSupplierController